// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Grouppage/Createpage.css
// module id = 1186
// module chunks = 0